import { SystemStyleObject } from "@chakra-ui/react";

// Menu is portalled to document.body, so it needs a z-index above whatever it
// opens over. Chakra: overlay 1300, modal 1400 — at 100 the menu rendered
// behind any modal (verify-receipt-modal is the first Select inside one).
export const menuPortalStyles = {
  menuPortal: (provided: any) => ({ ...provided, zIndex: 1500 }),
};

export const dropdownIndicatorStyle = (provided: SystemStyleObject) => ({
  ...provided,
  bg: "white",
  width: "20px",
});

export const indicatorSeparatorStyle = (provided: SystemStyleObject) => ({
  ...provided,
  display: "none",
});

export const baseOptionStyle = (
  provided: SystemStyleObject,
  isSelected: boolean
) => ({
  ...provided,
  bg: isSelected ? "primary.50 !important" : "white",
  color: "black !important",
  _hover: {
    bg: "primary.50",
  },
});

export const placeholderStyle = (provided: SystemStyleObject) => ({
  ...provided,
  marginLeft: "6px",
});

export const valueContainerStyle = (provided: SystemStyleObject) => ({
  ...provided,
  padding: "0 0 0 2px",
});
